<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/81/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            为深入贯彻落实习近平总书记关于“要加强产业工人队伍建设，加快建设一支宏大的知识型、技能型、创新型产业工人大军”的重要指示，着眼打造“技能双流”人才高地，做强高质量建设中国航空经济之都技能人才支撑。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/81/title-1.png" alt="" />
                    <div class="content">
                        以主导产业和急需紧缺产业技能人才需求为导向开展技能培训，对当年新取得高级工、技师、高级技师职业资格证书或职业技能等级证书的企业员工（含个体工商户）。
                    </div>
                </div>
                <div class="sscl">
                    <img class="top" src="./../assets/imgs/81/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            1.2021年10月29日后取得《双流区主导产业和急需紧缺产业技能人才需求目录》列示需求类别的高级工、技师、高级技师职业资格证书或职业技能等级证书。
                        </div>
                        <div class="des">
                            2.高级工、技师、高级技师申请人与区内企业（个体工商户）签订2年及以上劳动合同并且已缴纳社会保险12个月以上（劳动合同签订单位与社会保险缴纳单位必须一致），补贴由所在企业统一申报。
                        </div>
                        <div class="des">
                            3.申请人和申报企业应于职业资格证书或职业技能等级证书核发之日起12个月内提出申请，逾期视为自动放弃申报资格。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/81/title-3.png" alt="" />
                    <div class="content">
                        给予高级工个人1200元的一次性补贴；给予技师个人4000元的一次性补贴，给予其所在企业1000元的一次性补贴；给予高级技师个人5000元的一次性补贴，给予其所在企业2000元的一次性补贴。每户企业当年累计最高补贴不超过100万元。
                    </div>
                </div>

                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/81/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                企业申报
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                就业部门申报
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                人社部门复审
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                公示
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                发放补贴
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/78/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold;">
                        及时受理。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/78/title-6.png" alt="" />
                    <div class="content">
                        <div class="number" style="padding-left: 2.5rem;">
                            <span class="label">区人才服务中心：</span>
                            <div>
                                <a href="tel:028-85811773">028-85811773</a>
                            </div>
                        </div>
                        <div class="number" style="padding-left: 2.5rem;margin-top:0.2rem ;">
                            <span class="label">区就业局培训科：</span>
                            <div>
                                <a href="tel:028-85736261">028-85736261</a>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/81/code.png" />
                    <img class="text" src="../assets/imgs/81/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.77rem;
    }

    .technological-process {
        transform: translateY(-1.8rem);

        .sscl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
            line-height: 0.44rem;

            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: center;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                font-size: 0.32rem;
                font-weight: bold;
                color: #3D5AA3;

                .des {
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    padding-top: 0.1rem;
                    margin-top: 0.2rem;
                    position: relative;


                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4rem;
            }
        }
    }
}
</style>
